import {IPunchclockTime} from '../Client/IPunchclockTime'
import {IUser} from '../../DataStore/IUser'

export const GET_PUNCHCLOCK_TIMES         = 'GET_PUNCHCLOCK_TIMES'
export const GET_PUNCHCLOCK_TIMES_SUCCESS = 'GET_PUNCHCLOCK_TIMES_SUCCESS'
export const GET_PUNCHCLOCK_TIMES_FAILURE = 'GET_PUNCHCLOCK_TIMES_FAILURE'

export const START_PUNCHCLOCK_TIME         = 'START_PUNCHCLOCK_TIME'
export const START_PUNCHCLOCK_TIME_SUCCESS = 'START_PUNCHCLOCK_TIME_SUCCESS'
export const START_PUNCHCLOCK_TIME_FAILURE = 'START_PUNCHCLOCK_TIME_FAILURE'

export const END_PUNCHCLOCK_TIME         = 'END_PUNCHCLOCK_TIME'
export const END_PUNCHCLOCK_TIME_SUCCESS = 'END_PUNCHCLOCK_TIME_SUCCESS'
export const END_PUNCHCLOCK_TIME_FAILURE = 'END_PUNCHCLOCK_TIME_FAILURE'

interface GetPunchclockTimesAction {
    type: typeof GET_PUNCHCLOCK_TIMES
}

interface GetPunchclockTimesSuccessAction {
    type: typeof GET_PUNCHCLOCK_TIMES_SUCCESS,
    payload: {
        times: IPunchclockTime[]
    }
}

interface GetPunchclockTimesFailureAction {
    type: typeof GET_PUNCHCLOCK_TIMES_FAILURE
}

interface StartPunchclockTimeAction {
    type: typeof START_PUNCHCLOCK_TIME
}

interface StartPunchclockTimeSuccessAction {
    type: typeof START_PUNCHCLOCK_TIME_SUCCESS,
    payload: {
        time: IPunchclockTime
    }
}

interface StartPunchclockTimeFailureAction {
    type: typeof START_PUNCHCLOCK_TIME_FAILURE
}

interface EndPunchclockTimeAction {
    type: typeof END_PUNCHCLOCK_TIME
}

interface EndPunchclockTimeSuccessAction {
    type: typeof END_PUNCHCLOCK_TIME_SUCCESS,
    payload: {
        time: IPunchclockTime
    }
}

interface EndPunchclockTimeFailureAction {
    type: typeof END_PUNCHCLOCK_TIME_FAILURE
}

export type ActionTypes = GetPunchclockTimesAction | GetPunchclockTimesSuccessAction | GetPunchclockTimesFailureAction
    | StartPunchclockTimeAction | StartPunchclockTimeSuccessAction | StartPunchclockTimeFailureAction
    | EndPunchclockTimeAction | EndPunchclockTimeSuccessAction | EndPunchclockTimeFailureAction
